import React from 'react';
import { Box, Container, Typography, Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const LocationDetection: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="sm" sx={{ py: 8 }}>
            <Box sx={{ textAlign: 'center' }}>
                <CircularProgress sx={{ mb: 3 }} />
                <Typography variant="h4" gutterBottom>
                    Detecting Your Location
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                    We're detecting your location to set the appropriate default currency.
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate('/guest')}
                    sx={{ mr: 2 }}
                >
                    Continue as Guest
                </Button>
                <Button
                    variant="outlined"
                    onClick={() => navigate('/')}
                >
                    Go Back
                </Button>
            </Box>
        </Container>
    );
};

export default LocationDetection; 